export const INITIATIVES_TABLE_DATA_INDICES = {
	ASSIGNED_TO: 'assignedTo',
	CREATED_ON: 'createdOn',
	STATUS_ID: 'initiativeStatusId',
	TITLE: 'title',
	TYPE_ID: 'initiativeTypeId'
};
